// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__5BmcV","calendarButtons":"ClockData_calendarButtons__1cFbM"};